export default __webpack_public_path__ + "static/media/penguine.0c85e35b.svg";